import { createAsyncActionWithMeta } from "../../../../../libraries/packages/redux-utils/src/request/action";
import api from "../storeApi";

export const placelistGetAction = createAsyncActionWithMeta(
  "placelist_placelistGetAction_REQUEST",
  "placelist_placelistGetAction_SUCCESS",
  "placelist_placelistGetAction_FAILURE"
)<Parameters<typeof api.placelist.methods.get>, any, Error>();
